/**
 * @file index.js
 * @author xingminghua
 * @desc 拦截点击触发事件
 */

import {mapState, mapMutations} from 'vuex';
export default {
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore?.userInfoNew || {},
            vipInfo: state => state.lawStore.vipInfo || {},
            lawyerInfo: state => state.lawStore?.userInfoNew?.lawyer_info || {},
            authenticationStatus: state => state.lawStore.authenticationStatus
        })
    },
    methods: {
        ...mapMutations({
            emitEvent: 'EventBus/emitEvent'
        }),

        /**
         * 在任意元素事件的捕获阶段使用
         * @param {*} event 事件
         * @param {*} opts
         * @param {boolean} opts.isAuditStatus 是否判断快照
         * @returns
         */

        checkAuthentice(event, opts = {}) {
            // 个人信息审核通过，或使用审核快照检查通过
            const {authenticationStatus, lawyerInfo = {}, vipInfo = {}, userInfoNew} = this;
            const {isAuditStatus, isMtCheck} = opts;
            const isAuditStatusPass = isAuditStatus && lawyerInfo?.audit_status === '4';
            // 个人信息审核通过，或使用审核快照检查通过
            if ((+userInfoNew?.user_role === 2 || authenticationStatus === 7
                || isAuditStatusPass)
                && (!isMtCheck || (isMtCheck && vipInfo.validityStart))
            ) {
                return true;
            }
            // 阻止事件传播
            event && typeof event.preventDefault === 'function' && event.preventDefault();
            event && typeof event.stopPropagation === 'function' && event.stopPropagation();
            // 免体会员相关校验
            if (isMtCheck) {
                // 个人信息认证通过，且未领取过体验会员
                if ((authenticationStatus === 7 || isAuditStatusPass) && !vipInfo.validityStart) {
                    this.emitEvent({
                        name: 'global_free_vip_event',
                        payload: {
                            dialogType: 'receive'
                        }
                    });
                    return false;
                }
                // 个人信息认证未通过-引导去认证, 且未领取过体验会员
                if (authenticationStatus < 7 && !vipInfo.validityStart) {
                    this.emitEvent({
                        name: 'global_free_vip_event',
                        payload: {
                            dialogType: 'authentice'
                        }
                    });
                    return false;
                }
                let {vipStatus, privilege_info} = vipInfo;
                // 非会员
                if (!+vipStatus) {
                    // 体验会员过期用户
                    if (privilege_info && +privilege_info.vip_code_type === 6) {
                        return false;
                    }
                }
            }
            this.emitEvent({name: 'global_authentice'});
            return false;
        }
    }
};
